import React from "react"
import styles from "./styles.scss"

import Navigation from "./Navigation"
import AvailablePositions from "./AvailablePositions"
import logo from "images/saits-logo.png"
import CompanyInfo from "./CompanyInfo"
import FaIcon from "@fortawesome/react-fontawesome"
import HashLink from "components/HashLink"
import FooterEnd from "./FooterEnd"

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <img src={logo} className={styles.logo} alt="SAITS logo" />
      </div>

      <div className={styles.wrapper}>
        <b className={styles.title}>Redo att komma igång?</b>
        <span className={styles.text}>
          SAITS hjälper er och era kunder att nå era mål. Kom igång med ert
          projekt idag.
        </span>

        <HashLink to="/#contact" className={styles.link}>
          Starta ett projekt med oss{" "}
          <FaIcon icon={["fas", "arrow-right"]} className={styles.arrow} />
        </HashLink>
      </div>
      <Navigation />
      <AvailablePositions />
      <CompanyInfo />
    </div>
    <FooterEnd />
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx